<template>
  <h1>{{ teamTitle }}</h1>
  <div class="row justify-center screen-height">
    <div class="col-8">
      <team-announcements class="flex-h-50" />
      <div class="row">
        <div class="col-6">
          <icon-card label="Trainings" icon="fa-light fa-screen-users" />
        </div>
        <div class="col-6">
          <icon-card label="Tools" icon="fa-light fa-screwdriver-wrench" />
        </div>
      </div>
      <popular-posts/>
    </div>
    <div class="col-4">
      <goals-block class="flex-h-50" />
    </div>
  </div>
</template>

<script>
import TeamAnnouncements from '../components/MyDepartment/TeamAnnouncements.vue';
import GoalsBlock from '../components/MyDepartment/GoalsBlock.vue';
import IconCard from '../components/IconCard.vue'
import PopularPosts from '../components/MyDepartment/PopularPosts.vue';
import { category_from_role, fetchCurrentUser } from '../utils/fetch.js';

const DEFAULT_ROLES = ['editor', 'contributor', 'author', 'subscriber', 'administrator'];

export default {
  name: 'MyDepartment',
  components: {
    TeamAnnouncements,
    GoalsBlock,
    IconCard,
    PopularPosts
  },
  data() {
    return {
      userRoles: [],
      loading: true
    }
  },
  computed: {
    teamTitle() {
      // Filter out default roles and map to team names
      const teams = this.userRoles
        .filter(role => !DEFAULT_ROLES.includes(role))
        .map(role => category_from_role[role] ? category_from_role[role].replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : role);
      if (teams.length === 0) return 'My Team Page';
      return `${teams.join(' + ')} Page`;
    }
  },
  async created() {
    try {
      const user = await fetchCurrentUser();
      this.userRoles = user.roles || [];
    } catch (e) {
      this.userRoles = [];
    } finally {
      this.loading = false;
    }
  }
}
</script>